const titleKey = 'city_template.info.features_title_';
const textKey = 'city_template.info.features_text_';
const features = [
  {
    svgPath: 'simple-ic',
    title: titleKey,
    text: textKey,
  },
  {
    svgPath: 'green-energy-ic',
    title: titleKey,
    text: textKey,
  },
  {
    svgPath: 'ch-hotline-ic',
    title: titleKey,
    text: textKey,
  },
];
export default features;
